var map = {
	"./agentAvatar/BR_agent.png": 73617,
	"./agentAvatar/ID_agent.png": 60713,
	"./agentAvatar/MX_agent.png": 64565,
	"./agentAvatar/MY_agent.png": 18944,
	"./agentAvatar/PH_agent.png": 81851,
	"./agentAvatar/SG_agent.png": 85303,
	"./agentAvatar/TH&VN_agent.png": 25053,
	"./agentAvatar/TW_agent.png": 88445,
	"./agentAvatar/ar.png": 2152,
	"./agentAvatar/bank_id.png": 23233,
	"./agentAvatar/br.png": 52382,
	"./agentAvatar/cl.png": 22005,
	"./agentAvatar/co.png": 21042,
	"./agentAvatar/default.png": 36953,
	"./agentAvatar/es.png": 60585,
	"./agentAvatar/fr.png": 17456,
	"./agentAvatar/id.png": 41137,
	"./agentAvatar/in.png": 79329,
	"./agentAvatar/mx.png": 35318,
	"./agentAvatar/my.png": 47844,
	"./agentAvatar/ph.png": 59095,
	"./agentAvatar/pl.png": 50359,
	"./agentAvatar/sg.png": 60506,
	"./agentAvatar/th.png": 8645,
	"./agentAvatar/tw.png": 53457,
	"./agentAvatar/vn.png": 98638,
	"./arrow-right@2x.png": 84028,
	"./arrow_down@2x.png": 60438,
	"./avatar@2x.png": 32371,
	"./bank_bubble_right@4x.png": 28177,
	"./bank_ic_general_send_primary@2x.png": 15866,
	"./botAvatar/ar.png": 38997,
	"./botAvatar/bank_default_avatar.png": 42621,
	"./botAvatar/bank_id.png": 14598,
	"./botAvatar/br.png": 417,
	"./botAvatar/cl.png": 20979,
	"./botAvatar/co.png": 28007,
	"./botAvatar/default.png": 47733,
	"./botAvatar/es.png": 8911,
	"./botAvatar/fr.png": 81933,
	"./botAvatar/id.png": 43392,
	"./botAvatar/in.png": 4727,
	"./botAvatar/mx.png": 88192,
	"./botAvatar/my.png": 45302,
	"./botAvatar/ph.png": 19966,
	"./botAvatar/pl.png": 24908,
	"./botAvatar/sg.png": 11080,
	"./botAvatar/th.png": 11016,
	"./botAvatar/tw.png": 84368,
	"./botAvatar/vn.png": 25036,
	"./bubble_left@4x.png": 69421,
	"./bubble_right@4x.png": 42077,
	"./cb_ic_topup.png": 69228,
	"./cb_ic_topup@2x.png": 37659,
	"./cb_ic_withdraw.png": 45591,
	"./cb_ic_withdraw@2x.png": 56013,
	"./chatbot_avatar@2x.png": 82603,
	"./close@2x.png": 69623,
	"./drawer_close@2x.png": 9421,
	"./ic_cbot_topup@2x.png": 57221,
	"./ic_cbot_withdrawID@2x.png": 17171,
	"./ic_general_general_info_primary@2x.png": 10387,
	"./ic_general_send_primary@2x.png": 10630,
	"./ic_general_send_white@3x.png": 59485,
	"./ic_guarantee@2x.png": 32977,
	"./icon_transaction_bank.png": 88598,
	"./icon_transaction_bank@2x.png": 56712,
	"./icon_transaction_card@2x.png": 8251,
	"./intent/img_shopee_express.png": 87428,
	"./loading_circle.png": 61493,
	"./msg_failure.png": 28815,
	"./new-category/img_shopee_express.png": 4898,
	"./new-category/img_shopee_express_tw.png": 4551,
	"./no_order@2x.png": 98840,
	"./order_none@2x.png": 51501,
	"./order_others@2x.png": 61101,
	"./shape.png": 72895,
	"./shop_icon@2x.png": 56414,
	"./something_wrong@2x.png": 26014,
	"./update-available.png": 92134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79650;